var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomModal',{attrs:{"modalOpen":_vm.modalOpen},on:{"toggleModal":function($event){return _vm.toggleModal()}}})}
var staticRenderFns = []

export { render, staticRenderFns }